import type { OktaWordmarkProps } from './types';

/**
 * Okta's wordmark, for the login button.
 *
 * **The word only. The sunburst icon is dropped** — the four letters are the
 * recognisable half, and at button size the icon is a smudge beside them. From
 * Luna's `okta-logo.svg`, with the viewBox tightened to the letters' ink bounds
 * so the `height` prop means the height of the word.
 *
 * **`currentColor`, not a fill**, so it takes the button's text colour rather
 * than one white drifting from another.
 */

/** From the tightened viewBox: 74 wide by 28 tall. */
const ASPECT_RATIO = 74 / 28;

const WORDMARK_PATH =
  'M115.466 27.5989C111.912 27.5989 109.401 24.829 109.401 21.1935C109.401 17.558 111.914 14.788 115.466 14.788C119.018 14.788 121.46 17.558 121.46 21.1935C121.46 24.829 118.984 27.5989 115.466 27.5989ZM114.891 31.4129C117.763 31.4129 120.203 30.2982 121.745 27.9593C122.032 30.2258 123.683 31.0543 125.764 31.0543H127.415V27.4559H126.698C125.514 27.4559 125.226 26.88 125.226 25.548V11.3345H121.423V14.2492C120.131 12.1983 117.691 10.9741 114.891 10.9741C109.903 10.9741 105.308 15.1484 105.308 21.1935C105.308 27.2386 109.902 31.4129 114.891 31.4129ZM95.2975 26.4825C95.2975 29.7206 97.3078 31.0525 99.711 31.0525H104.341V27.4541H100.967C99.5683 27.4541 99.2811 26.9135 99.2811 25.5462V14.9311H104.341V11.3327H99.2811V4.7135H95.2975V26.4825ZM77.1749 31.0525H81.1585V22.5961H82.4869L89.2701 31.0525H94.295L85.646 20.3297L92.2847 11.3345H87.799L82.3795 18.927H81.1585V4.7135H77.1749V31.0525ZM64.2551 10.9741C58.6928 10.9741 54.0996 15.1484 54.0996 21.1935C54.0996 27.2386 58.6928 31.4129 64.2551 31.4129C69.8173 31.4129 74.4105 27.2386 74.4105 21.1935C74.4105 15.1484 69.8173 10.9741 64.2551 10.9741ZM64.2551 27.5972C60.7014 27.5972 58.1907 24.8273 58.1907 21.1917C58.1907 17.5562 60.7031 14.7863 64.2551 14.7863C67.807 14.7863 70.3194 17.5562 70.3194 21.1917C70.3194 24.8273 67.807 27.5972 64.2551 27.5972Z';

export const OktaWordmark = ({ height = 22 }: OktaWordmarkProps) => (
  <svg
    width={Math.round(height * ASPECT_RATIO)}
    height={height}
    viewBox="54 4 74 28"
    xmlns="http://www.w3.org/2000/svg"
    // Decorative: the button is named by its own text, which says "Login with
    // Okta". Announcing it twice helps nobody.
    aria-hidden
    focusable={false}
  >
    <path d={WORDMARK_PATH} fill="currentColor" />
  </svg>
);
